import * as React from "react";

/**
 * 404页面
 */
export default () => {

    return (
        <div className="notfound-wrapper flexc flexjc flexic h">
            <img src={require('../../assets/images/icon-404.png')} alt=""/>
            <h1 style={{fontFamily: 'Arial', fontSize: 80, color: '#1890ff'}}>404</h1>
            <p className="f18">页面不见了</p>
        </div>
    )
}